import { inject, Pipe, PipeTransform } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { LunarDateService } from '../services/app';
import dayjs from 'dayjs';

@Pipe({ name: 'lunarDay', standalone: true })
export class LunarDayPipe implements PipeTransform {
  private lunarDateService = inject(LunarDateService);

  transform(date: NgbDate): string {
    const lunarDate = this.lunarDateService.getLunarDate(
      date.day,
      date.month,
      date.year,
    );

    let result = `${lunarDate.day}`;
    if (lunarDate.day === 1 || date.day === 1) {
      result = `${lunarDate.day}/${lunarDate.month}`;
    }

    return result.replace(/-/g, '0');
  }
}

@Pipe({ name: 'lunarDate', standalone: true })
export class LunarDatePipe implements PipeTransform {
  transform(date: Date | null, format = 'DD/MM/YYYY'): string {
    if (date) {
      const day = dayjs(date);
      return day.lunar(format).replace(/-/g, '0');
    } else return '';
  }
}
